import { Checkbox as Check, ConfigProvider } from "antd";

const Checkbox = ({
  key,
  onChange,
  className,
  children,
  defaultChecked,
  checked,
  indeterminate,
  colorPrimary = "#1bbb6b",
  colorTick = "#fff",
}) => {
  const controlledProps =
    checked !== undefined ? { checked } : { defaultChecked };
  return (
    <ConfigProvider
      theme={{
        components: {
          Checkbox: {
            colorPrimary: colorPrimary,
            colorPrimaryHover: colorPrimary,
            colorWhite: colorTick,
          },
        },
      }}
    >
      <Check
        onChange={onChange}
        key={key}
        indeterminate={indeterminate}
        className={`${className}`}
        {...controlledProps}
      >
        {children}
      </Check>
    </ConfigProvider>
  );
};

export default Checkbox;
